import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-time-field-playground',
  templateUrl: './time-field-playground.component.html',
  styleUrls: ['./time-field-playground.component.scss'],
})
export class TimeFieldPlaygroundComponent {
  readonly form: FormGroup = this.fb.group({
    from: ['08:00 AM', [Validators.required]],
    to: ['09:30 PM'],
    disabled: [false],
  });

  constructor(private readonly fb: FormBuilder) {}

  get disabled(): boolean {
    return Boolean(this.form.get('disabled')?.value);
  }
}
